export default "__VITE_ASSET__DSOsv5nV__"